<template>
	<button type="button" class="wood-sample" :class="{'active' : isActive}" role="radio" :aria-checked="isActive ? 'true' : 'false'" :aria-label="finishName" @click.prevent="onSelect">
		<div class="bb-wood-type">
			<div class="uk-flex uk-flex-middle">
                <div class="img-container" :style="imgStyle" aria-hidden="true"></div>
                <p>{{ finishName }}</p>
            </div>
		</div>
	</button>
</template>

<script>
	export default {
		props : {
			finish : Object,
			selected :  Object
		},
		name : "wood-finish",
		components: {},
		methods : {
			onSelect(){
				this.$emit('select',this.finish);
			}
		},
		computed : {
			finishName(){
				return (this.finish.name == undefined)? "" : this.finish.name;
			},
			finishImage(){
				return (this.finish.image == undefined)? "" : this.finish.image.webPath;
			},
			imgStyle(){
				return `background-image: url(${this.finishImage}/200);`;
			},
			isActive() {
				if(this.selected == null ) return false;
				return this.finish.id == this.selected.id;
			}
		}
	}
</script>